module.exports = __webpack_public_path__ + "img/go-to-liveabc-button.4e60c669.png";